<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group w-702px mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <TableControlShowState v-model="filter.status"></TableControlShowState>
        <button class="btn btn-primary w-88px" @click="getBus">搜尋</button>
      </div>

      <!-- table -->
      <div class="table">
        <div class="table-head">
          <!-- column head -->
          <div class="form-item d-flex px-5 h-60px align-center">
            <h5 class="col-buname">BU Name</h5>
            <h5 class="col-show ml-auto">顯示/隱藏</h5>
            <h5 class="col-edit">編輯</h5>
          </div>
        </div>
        <div class="table-body">
          <div
            class="form-item d-flex h-60px align-center"
            :class="{ active: item.isChecked }"
            v-for="item in bus"
            :key="item.buname"
          >
            <div class="h5 col-buname">{{ item.name }}</div>

            <div class="h5 col-show ml-auto d-flex align-center">
              <FormSwitch
                v-model="item.support_status"
                @changeStatus="changePublish(item.support_status, item.id)">
              </FormSwitch>
            </div>
            <div class="h5 col-edit ">
              <button class="btn square" @click="toSupportEdit(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- table footer -->
      <Pagination @handleNextPreEvent="getBus" model="bupage"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TableControlShowState from '@/components/TableControlShowState.vue';
import Pagination from '@/components/Pagination.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    TableControlShowState,
    Pagination,
    FormSwitch,
  },
  computed: {
    ...mapState('bupage', ['bus', 'filter']),
  },
  methods: {
    ...mapActions('bupage', {
      clear: 'clear',
      getBus: 'find',
      publish: 'supportPublish',
    }),
    toSupportEdit(id) {
      this.$router.push({
        name: 'SupportEdit',
        params: { id },
      });
    },
    changePublish(status, id) {
      this.publish({
        ids: id ? [id] : this.isCheckedListIds,
        status,
      }).then(() => {
        this.getBus();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-buname {
    width: 150px;
    margin-right: 20px;
  }

  .col-show {
    margin-right: 40px;
  }
}
</style>
